import { useState, Children, isValidElement, ReactElement } from 'react'

import classNames from 'classnames'

interface ShareTabPanelProps {
  label: string
  children: React.ReactNode
}

export const ShareTabPanel = ({ children }: ShareTabPanelProps) => {
  return <>{children}</>
}

interface ShareTabsProps {
  children: React.ReactNode
}

const ShareTabs = ({ children }: ShareTabsProps) => {
  const panels = Children.toArray(children).filter(
    isValidElement
  ) as ReactElement<ShareTabPanelProps>[]
  const [active, setActive] = useState(0)

  return (
    <nav>
      <div className="flex border-b border-gray-200">
        {panels.map((panel, idx) => (
          <button
            key={panel.props.label}
            className={classNames(
              'px-1 py-4 w-1/2 text-center text-sm font-medium border-b-2 focus:outline-none cursor-pointer',
              active === idx
                ? 'text-indigo-600 border-indigo-500'
                : 'text-gray-500 hover:text-gray-700 hover:border-gray-300 border-transparent'
            )}
            onClick={() => setActive(idx)}
            type="button"
          >
            {panel.props.label}
          </button>
        ))}
      </div>
      <div className="mt-4">{panels[active]}</div>
    </nav>
  )
}

export default ShareTabs
